import { gql } from '@apollo/client';

/**
 * Base Media fragment without fields that require arguments
 * Note: imgixUrl is excluded because it requires arguments
 */
/**
 * Avatar-safe media fields for user listings.
 * Omits url/cloudFrontUrl (non-null in schema) so a broken media record does not fail the whole query.
 */
export const MEDIA_AVATAR_FRAGMENT = gql`
  fragment MediaAvatarFields on Media {
    id
    name
    imgixUrl(options: { w: 200, h: 200, fit: "crop" })
  }
`;

export const MEDIA_FRAGMENT = gql`
  fragment MediaFields on Media {
    id
    name
    path
    type
    mimeType
    createdAt
    updatedAt
    entityId
    entityType
    url {
      url
      expiresIn
    }
    cloudFrontUrl {
      url
      expiresIn
    }
    imgixUrl(options: { w: 200, h: 200, fit: "crop" })
  }
`;

/**
 * Media fragment with createdBy user information
 */
export const MEDIA_WITH_USER_FRAGMENT = gql`
  fragment MediaWithUser on Media {
    ...MediaFields
    createdBy {
      id
      email
      firstName
      lastName
      fullName
    }
  }
  ${MEDIA_FRAGMENT}
`;
